<template>
  <div class="add-owner-committee-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('addOwnerCommittee.title')" :subtitle="$t('addOwnerCommittee.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="saveOwnerCommitteeInfo">
          {{ $t('common.save') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 业委会信息表单面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('addOwnerCommittee.page.infoTitle') }}</span>
      </div>

      <el-form ref="form" :model="addOwnerCommitteeInfo" :rules="rules" label-width="120px" label-position="right"
        class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.name')" prop="name">
              <el-input v-model.trim="addOwnerCommitteeInfo.name" :placeholder="$t('addOwnerCommittee.requiredName')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.sex')" prop="sex">
              <el-select v-model="addOwnerCommitteeInfo.sex" :placeholder="$t('addOwnerCommittee.requiredSex')"
                class="w-full">
                <el-option disabled value="">{{ $t('addOwnerCommittee.requiredSex') }}</el-option>
                <el-option :label="$t('addOwnerCommittee.male')" value="B">{{ $t('addOwnerCommittee.male') }}</el-option>
                <el-option :label="$t('addOwnerCommittee.female')" value="G">{{ $t('addOwnerCommittee.female') }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.phone')" prop="link">
              <el-input v-model.trim="addOwnerCommitteeInfo.link" :placeholder="$t('addOwnerCommittee.requiredPhone')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.idCard')" prop="idCard">
              <el-input v-model.trim="addOwnerCommitteeInfo.idCard"
                :placeholder="$t('addOwnerCommittee.requiredIdCard')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.address')" prop="address">
              <el-input v-model.trim="addOwnerCommitteeInfo.address"
                :placeholder="$t('addOwnerCommittee.requiredAddress')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.position')" prop="position">
              <el-input v-model.trim="addOwnerCommitteeInfo.position"
                :placeholder="$t('addOwnerCommittee.requiredPosition')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.post')" prop="post">
              <el-input v-model.trim="addOwnerCommitteeInfo.post" :placeholder="$t('addOwnerCommittee.requiredPost')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.postDesc')">
              <el-input v-model.trim="addOwnerCommitteeInfo.postDesc"
                :placeholder="$t('addOwnerCommittee.optionalPostDesc')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.appointTime')" prop="appointTime">
              <el-input v-model.trim="addOwnerCommitteeInfo.appointTime"
                :placeholder="$t('addOwnerCommittee.requiredAppointTime')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.curTime')" prop="curTime">
              <el-input v-model.trim="addOwnerCommitteeInfo.curTime"
                :placeholder="$t('addOwnerCommittee.requiredCurTime')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.state')" prop="state">
              <el-select v-model="addOwnerCommitteeInfo.state" :placeholder="$t('addOwnerCommittee.requiredState')"
                class="w-full">
                <el-option disabled value="">{{ $t('addOwnerCommittee.requiredState') }}</el-option>
                <el-option :label="$t('addOwnerCommittee.onJob')" value="1000">{{ $t('addOwnerCommittee.onJob') }}</el-option>
                <el-option :label="$t('addOwnerCommittee.leaveJob')" value="2000">{{ $t('addOwnerCommittee.leaveJob') }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addOwnerCommittee.remark')">
              <el-input v-model.trim="addOwnerCommitteeInfo.remark" type="textarea"
                :placeholder="$t('addOwnerCommittee.optionalRemark')" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- (3)(4) 紧急联系人面板 + 表格 -->
    <div class="ds-panel">
      <ds-toolbar :total="addOwnerCommitteeInfo.contracts.length" :show-column-setting="false" :show-density="false"
        :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('addOwnerCommittee.emergencyContact') }}</span>
        </template>
        <template #right>
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="addContract">
            {{ $t('common.add') }}
          </el-button>
        </template>
      </ds-toolbar>

      <ds-data-table :data="addOwnerCommitteeInfo.contracts" density="default" border
        :empty-description="$t('addOwnerCommittee.page.empty')">
        <el-table-column :label="$t('addOwnerCommittee.contactRelationship')" align="center" min-width="130">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.relName" :placeholder="$t('addOwnerCommittee.requiredRelationship')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('addOwnerCommittee.contactName')" align="center" min-width="130">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.name" :placeholder="$t('addOwnerCommittee.requiredName')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('addOwnerCommittee.contactPhone')" align="center" min-width="140">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.link" :placeholder="$t('addOwnerCommittee.requiredPhone')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('addOwnerCommittee.contactAddress')" align="center" min-width="200">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.address" :placeholder="$t('addOwnerCommittee.requiredAddress')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="deleteContract(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <!-- 表单操作区 -->
    <div class="ds-form-actions">
      <el-button icon="el-icon-back" @click="goBack">
        {{ $t('common.back') }}
      </el-button>
      <el-button type="primary" icon="el-icon-check" @click="saveOwnerCommitteeInfo">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { saveOwnerCommittee } from '@/api/owner/addOwnerCommitteeApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'AddOwnerCommitteeList',
  components: {
    DsPageHeader,
    DsToolbar,
    DsDataTable
  },
  data() {
    return {
      addOwnerCommitteeInfo: {
        ocId: '',
        name: '',
        sex: '',
        link: '',
        idCard: '',
        address: '',
        position: '',
        post: '',
        postDesc: '',
        appointTime: '',
        curTime: '',
        state: '',
        remark: '',
        contracts: []
      },
      rules: {
        name: [
          { required: true, message: this.$t('addOwnerCommittee.requiredName'), trigger: 'blur' },
          { max: 30, message: this.$t('addOwnerCommittee.maxName', { max: 30 }), trigger: 'blur' }
        ],
        sex: [
          { required: true, message: this.$t('addOwnerCommittee.requiredSex'), trigger: 'change' },
          { max: 12, message: this.$t('addOwnerCommittee.maxSex', { max: 12 }), trigger: 'blur' }
        ],
        link: [
          { required: true, message: this.$t('addOwnerCommittee.requiredPhone'), trigger: 'blur' },
          { max: 11, message: this.$t('addOwnerCommittee.maxPhone', { max: 11 }), trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: this.$t('addOwnerCommittee.requiredIdCard'), trigger: 'blur' },
          { max: 18, message: this.$t('addOwnerCommittee.maxIdCard', { max: 18 }), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('addOwnerCommittee.requiredAddress'), trigger: 'blur' },
          { max: 256, message: this.$t('addOwnerCommittee.maxAddress', { max: 256 }), trigger: 'blur' }
        ],
        position: [
          { required: true, message: this.$t('addOwnerCommittee.requiredPosition'), trigger: 'blur' },
          { max: 64, message: this.$t('addOwnerCommittee.maxPosition', { max: 64 }), trigger: 'blur' }
        ],
        post: [
          { required: true, message: this.$t('addOwnerCommittee.requiredPost'), trigger: 'blur' },
          { max: 64, message: this.$t('addOwnerCommittee.maxPost', { max: 64 }), trigger: 'blur' }
        ],
        postDesc: [
          { max: 64, message: this.$t('addOwnerCommittee.maxPostDesc', { max: 64 }), trigger: 'blur' }
        ],
        appointTime: [
          { required: true, message: this.$t('addOwnerCommittee.requiredAppointTime'), trigger: 'blur' },
          { max: 256, message: this.$t('addOwnerCommittee.maxAppointTime', { max: 256 }), trigger: 'blur' }
        ],
        curTime: [
          { required: true, message: this.$t('addOwnerCommittee.requiredCurTime'), trigger: 'blur' },
          { max: 256, message: this.$t('addOwnerCommittee.maxCurTime', { max: 256 }), trigger: 'blur' }
        ],
        state: [
          { required: true, message: this.$t('addOwnerCommittee.requiredState'), trigger: 'change' },
          { max: 12, message: this.$t('addOwnerCommittee.maxState', { max: 12 }), trigger: 'blur' }
        ],
        remark: [
          { max: 200, message: this.$t('addOwnerCommittee.maxRemark', { max: 200 }), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    addContract() {
      this.addOwnerCommitteeInfo.contracts.push({
        id: this.generateUUID(),
        relName: '',
        name: '',
        link: '',
        address: ''
      })
    },
    deleteContract(contract) {
      const index = this.addOwnerCommitteeInfo.contracts.findIndex(item => item.id === contract.id)
      if (index !== -1) {
        this.addOwnerCommitteeInfo.contracts.splice(index, 1)
      }
    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    async saveOwnerCommitteeInfo() {
      try {
        await this.$refs.form.validate()

        this.addOwnerCommitteeInfo.communityId = getCommunityId()
        const response = await saveOwnerCommittee(this.addOwnerCommitteeInfo)

        if (response.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.goBack()
        } else {
          this.$message.error(response.msg || this.$t('addOwnerCommittee.saveError'))
        }
      } catch (error) {
        console.error('保存失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-owner-committee-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }
}

/* 面板标题栏 */
.ds-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--ds-spacing-md);
  margin-bottom: var(--ds-spacing-lg);
  border-bottom: 1px solid var(--ds-gray-200);
}

.ds-panel__title {
  font-size: var(--ds-font-size-lg);
  font-weight: 600;
  color: var(--ds-gray-800);
}

/* 表单 */
.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
